import { useEffect, useState } from "react";
import FileUploader from "../../../components/FileUploader";

const WidowPostVideoProofs = ({translation, postVideos, setCurrentStep, postSlug, isUpdate}) => {

  const [oldPlaceVideo, setOldPlaceVideo] = useState(null)
  const [uploadedPlaceVideo, setUploadedPlaceVideo] = useState(false);

  
  useEffect(()=>{
    if (postVideos){
      setOldPlaceVideo(postVideos?.videos?.place_video)
      setUploadedPlaceVideo(true)
    }
  }, [postVideos])
  

  return (
    <>
      <div className="pt-2 pb-5 space-y-4">
        <div className="flex flex-col space-y-1">
          <label htmlFor="place_video" className="block font-semibold mb-2 dark:text-white">{translation.other.widow_house_video}</label>
          
          <FileUploader
            key="place_video_uploader"
            fileNameInDB={'place_video'}
            allowedTypes={['mp4', 'mpeg', 'mp4', 'avi', 'mov']}
            onSuccess={(filePath)=>{
              setUploadedPlaceVideo(true)
              setOldPlaceVideo(filePath)
            }}
            generateUrlEndpoint={`${process.env.REACT_APP_BACKEND_DOMAIN}/post/generate-presigned-url/`}
            updateBackendEndpoint={`${process.env.REACT_APP_BACKEND_DOMAIN}/post/upload-post-video-path/`}
            additionalFormData={{'slug': postSlug}}
            maxSizeMB={500}
             
            awsUploadDestination={'posts/username/videos/place'}
            description={translation.other.widow_house_video_description}
            showPreview={oldPlaceVideo ? `${process.env.REACT_APP_CDN_URL}/${oldPlaceVideo}` : null} 

          />

        </div>

      </div>

      <div className="flex space-x-3">
        {isUpdate && 
          <button
            onClick={()=>{
              setCurrentStep("create_bank_details");
            }}
            className="w-full rounded-md bg-blue-500 text-white font-extrabold px-4 py-2 hover:bg-blue-600 "
          >
            {translation.back}
          </button>
        }
        
        <button
          type="button"
          onClick={() => {setCurrentStep("attach_doc_proofs");}}
          className="w-full rounded-md bg-blue-500 text-white font-extrabold px-4 py-2 hover:bg-blue-600 disabled:bg-gray-400 disabled:text-gray-200 disabled:cursor-not-allowed"
          disabled={!uploadedPlaceVideo}

        >
          {translation.next}
        </button>
      </div>
    </>
  )
}

export default WidowPostVideoProofs;